import React from "react";

const CheckMarkIcon = props => (
  <svg
    className="checkmark"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
  >
    <path
      className="checkmark__check"
      fill="none"
      stroke="#009600"
      d="M3 16l7.1 7.2 16.7-16.8"
    />
  </svg>
);

export { CheckMarkIcon };



// WEBPACK FOOTER //
// ./src/modules/ContactForm/components/CheckMark.js